import { Navigate, useLocation } from "react-router-dom";
import RoleGuardRoute from "../../../components/layout/RoleGuardRoute";
import ContractorPortalLayout from "./ContractorPortalLayout";
import ContractorDashboardPage from "./pages/ContractorDashboardPage";
import ContractorProjectsPage from "./pages/ContractorProjectsPage";
import ContractorProjectDetailPage from "./pages/ContractorProjectDetailPage";
import ContractorContractsPage from "./pages/ContractorContractsPage";
import ContractorMasterContractSignPage from "./pages/ContractorMasterContractSignPage";
import ContractorPaymentsPage from "./pages/ContractorPaymentsPage";
import ContractorProfilePage from "./pages/ContractorProfilePage";
import ContractorSupervisionHubPage from "./pages/ContractorSupervisionHubPage";
import { CONTRACTOR_PORTAL_BASE } from "./contractorPortalNav";

const withContractorGuard = (element) => (
  <RoleGuardRoute requireContractor>{element}</RoleGuardRoute>
);

/** Legacy /SLN/ContractorPortal/* → /SLN/Contractor/* */
const LegacyContractorPortalRedirect = () => {
  const location = useLocation();
  const suffix = location.pathname.replace(/^\/SLN\/ContractorPortal/i, "");
  const target = `${CONTRACTOR_PORTAL_BASE}${suffix || ""}` || CONTRACTOR_PORTAL_BASE;
  return <Navigate to={`${target}${location.search || ""}`} replace />;
};

/**
 * Contractor Portal routes — unified under /SLN/Contractor.
 * Legacy /SLN/ContractorPortal/* redirects here for backward compatibility.
 */
export const contractorPortalSlnRouteEntries = [
  {
    path: "Contractor",
    element: withContractorGuard(<ContractorPortalLayout />),
    children: [
      {
        index: true,
        element: <ContractorDashboardPage />,
      },
      {
        path: "dashboard",
        element: <ContractorDashboardPage />,
      },
      {
        path: "projects",
        element: <ContractorProjectsPage />,
      },
      {
        path: "projects/:id",
        element: <ContractorProjectDetailPage />,
      },
      {
        path: "contracts",
        element: <ContractorContractsPage />,
      },
      {
        path: "contracts/:id",
        element: <ContractorMasterContractSignPage />,
      },
      {
        path: "payments",
        element: <ContractorPaymentsPage />,
      },
      {
        path: "profile",
        element: <ContractorProfilePage />,
      },
    ],
  },
  {
    // Workspace نظارت — خارج از تب‌های پورتال تا UX مثل /SLN/Supervisor باشد
    path: "Contractor/supervision",
    element: withContractorGuard(<ContractorSupervisionHubPage />),
  },
  {
    path: "Contractor/ContractorPortal",
    element: withContractorGuard(
      <Navigate to={CONTRACTOR_PORTAL_BASE} replace />
    ),
  },
  {
    path: "ContractorPortal",
    element: withContractorGuard(<LegacyContractorPortalRedirect />),
  },
  {
    path: "ContractorPortal/*",
    element: withContractorGuard(<LegacyContractorPortalRedirect />),
  },
];
